import { DCUIContent } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { DCUIThemingErrorPageValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";

export const getDCUIThemingErrorPageValidationErrors = (
    isUsingDCUIVersion2: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    dcuiContent: DCUIContent,
): DCUIThemingErrorPageValidationErrors => {
    let count = 0;
    let titleError = null;
    let instructionsError = null;
    let transactionIdLabelError = null;

    if (isUsingDCUIVersion2 && hasDisplayableDocumentCaptureAttributes) {
        if (!dcuiContent.error.header) {
            count += 1;
            titleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.error.message) {
            count += 1;
            instructionsError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent.error.transactionId) {
            count += 1;
            transactionIdLabelError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
    }

    return {
        titleError,
        instructionsError,
        transactionIdLabelError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.error.tabName}
            errorCount={count}
        />
    };
};